import { Injectable, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { PaymentService, STRIPE_SESSION_ID } from './payment.service';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  router = inject(Router);
  paymentService = inject(PaymentService);
  private readonly HISTORY_KEY = '__nav_hist__';
  private _history: string[] = JSON.parse(sessionStorage.getItem(this.HISTORY_KEY) ?? '[]');
  private _isNavigatingBack = false;

  init() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (this._isNavigatingBack) {
          this._isNavigatingBack = false;
          return;
        }
        const urlToSave = NavigationService.getUrlWithoutParameter(event.urlAfterRedirects, STRIPE_SESSION_ID);
        this._history.push(urlToSave);
        sessionStorage.setItem(this.HISTORY_KEY, JSON.stringify(this._history));

        this.paymentService.checkForSuccessfulPurchase();
      }
    });
  }

  back(): void {
    this._history.pop();
    sessionStorage.setItem(this.HISTORY_KEY, JSON.stringify(this._history));
    if (this._history.length > 0) {
      const lastEntry = this._history[this._history.length - 1];
      this._isNavigatingBack = true;
      this.router.navigateByUrl(lastEntry);
    } else {
      this._isNavigatingBack = true;
      this.router.navigateByUrl('/');
    }
  }

  static getUrlWithoutParameter(url: string, paramName: string): string {
    if (!url || !paramName) {
      return '';
    }
    const pattern = new RegExp(`([?&])${paramName}=[^&]+`);
    return url.replace(pattern, '');
  }
}
